export type WebsiteSource = 'ga4' | 'searchConsole' | 'clarity' | 'cloudflare' | 'clarityCitations' | 'googleAds' | 'metaAds' | 'technical';
export type WebsiteDomain = 'main' | 'play';
export const PLAY_GA4_MEASUREMENT_ID = 'G-CH2215MW7D';
export type WebsiteSourceStatus = 'ready' | 'empty' | 'not_configured' | 'access_required' | 'unavailable' | 'partial';
export interface WebsitePeriod { from: string; to: string }
export interface WebsiteRange { current: WebsitePeriod; previous: WebsitePeriod }
export interface WebsiteSourceState {
  source: WebsiteSource; status: WebsiteSourceStatus; fetchedAt: number | null;
  message: string | null; timezone: string | null; truncated: boolean;
}
export interface WebsiteMetric { key: string; value: number | null; previous: number | null; unit: 'count' | 'percent' | 'seconds' | 'position' | 'currency'; lowerIsBetter?: boolean }
export interface WebsiteRow { label: string; values: Record<string, number | null>; url?: string }
export interface WebsiteSeriesPoint { date: string; values: Record<string, number | null> }
export interface WebsiteDataset {
  state: WebsiteSourceState; metrics: WebsiteMetric[]; series: WebsiteSeriesPoint[];
  tables: Record<string, WebsiteRow[]>; notes: string[]; currency?: string; availablePeriods?: WebsitePeriod[];
}
export interface WebsiteAnalyticsReport {
  range: WebsiteRange; generatedAt: number; datasets: Partial<Record<WebsiteSource, WebsiteDataset>>;
  domains?: Partial<Record<WebsiteDomain, WebsiteDataset>>;
}
export interface WebsiteAnalyticsSettings {
  revision: number; ga4PropertyId: string; searchConsoleSite: string; clarityProjectId: string;
  appGa4PropertyId: string; googleAdsCustomerId: string; googleAdsLoginCustomerId: string;
  metaAdsAccountId: string; googleAdsApiVersion: string; cloudflareZoneId?: string;
}
export interface WebsiteAnalyticsSetup {
  settings: WebsiteAnalyticsSettings; serviceAccountEmail: string | null; canConfigure: boolean;
  secrets: { clarityToken: boolean; googleAdsDeveloperToken: boolean; metaAdsToken: boolean; cloudflareToken?: boolean };
  collection: { lastSuccessAt: number | null; firstSnapshotAt: number | null; error: string | null };
  tracking: { domain: string; ga4MeasurementId: string; gtmId: string; clarityProjectId: string; metaPixelId: string; playDomain?: string; playGa4MeasurementId?: string };
}
export interface WebsiteSettingsUpdate {
  settings: WebsiteAnalyticsSettings;
  secrets?: Partial<Record<'clarityToken' | 'googleAdsDeveloperToken' | 'metaAdsToken' | 'cloudflareToken', string | null>>;
}
export interface WebsiteCitationPreview { projectName: string; period: WebsitePeriod; dataset: WebsiteDataset }
